module.exports = __webpack_public_path__ + "img/ripple.461f3627.png";